import { PropsBase, PropsMulti, PropsRange, PropsSingle } from 'react-day-picker';

export const CALENDAR_MODE = {
  SINGLE: 'single',
  RANGE: 'range',
  MULTIPLE: 'multiple',
} as const;

export type CalendarMode = (typeof CALENDAR_MODE)[keyof typeof CALENDAR_MODE];

interface CalendarBaseProps {
  /**
   * BCP 47 locale identifier (e.g., 'en-US', 'fr-FR', 'ja-JP') used for
   * formatting the month / year display in the header.
   * @default 'en-US'
   */
  localeCode?: string;
}

export type CalendarProps =
  | (PropsBase & PropsSingle & CalendarBaseProps & { mode: typeof CALENDAR_MODE.SINGLE })
  | (PropsBase & PropsRange & CalendarBaseProps & { mode: typeof CALENDAR_MODE.RANGE })
  | (PropsBase & PropsMulti & CalendarBaseProps & { mode: typeof CALENDAR_MODE.MULTIPLE });
